import { getTypeById } from "@commonqr/shared/config/identityTypes";
import { buildWhatsAppUrl, buildEmailUrl } from "@commonqr/shared/utils/contactBar";

interface ProfileCTAProps {
  profileType: string;
  accentColor?: string;
  profile: {
    phone: string | null;
    email: string | null;
    whatsapp: string | null;
    website: string | null;
    contactGreeting?: string | null;
  };
}

export function ProfileCTA({ profileType, accentColor, profile }: ProfileCTAProps) {
  const identityType = getTypeById(profileType);
  const label = identityType?.primaryCTA.label ?? "Connect";
  const action = identityType?.primaryCTA.action ?? "contact";
  const color = accentColor ?? identityType?.accentColor ?? "#6366f1";

  let href = "#";
  switch (action) {
    case "save_contact":
      href = `/api/v1/p/${window.location.pathname.split("/").pop()}/vcard`;
      break;
    case "booking":
    case "consult":
      href = profile.email
        ? buildEmailUrl(profile.email, profileType, profile.contactGreeting)
        : profile.whatsapp || profile.phone
        ? buildWhatsAppUrl(profile.whatsapp ?? profile.phone ?? "", profileType, profile.contactGreeting)
        : "#book";
      break;
    case "menu":
      href = profile.website ?? "#menu";
      break;
    case "shop":
    case "quote":
    case "request":
      href = profile.whatsapp || profile.phone
        ? buildWhatsAppUrl(profile.whatsapp ?? profile.phone ?? "", profileType, profile.contactGreeting)
        : "#";
      break;
    case "follow":
      href = profile.website ?? "#";
      break;
    case "donate":
      href = profile.website ?? "#donate";
      break;
    case "enrol":
      href = profile.email
        ? buildEmailUrl(profile.email, profileType, profile.contactGreeting)
        : "#enrol";
      break;
    case "portfolio":
      href = profile.website ?? "#portfolio";
      break;
    default:
      href = profile.email
        ? buildEmailUrl(profile.email, profileType, profile.contactGreeting)
        : "#";
  }

  return (
    <a
      href={href}
      style={{ backgroundColor: color }}
      className="w-full inline-flex items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-semibold text-white mt-2 min-h-[48px]"
    >
      {label}
    </a>
  );
}